import {
    CardHeader,
    Divider,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { DigestReport } from '../../sic-lib/api/activityReport/types/ActivityReport';

interface Props {
    report: DigestReport | undefined;
}

export default function AllContactActivity({ report }: Props) {
    const { classes } = useStyles();

    if (!report) {
        return <></>;
    }

    return (
        <Paper className={classes.root}>
            <CardHeader title="All Contacts Activity" />
            <Divider />
            <TableContainer component={Paper}>
                <Table size="small" aria-label="all-contacts-activity">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">New Leads</TableCell>
                            <TableCell align="center">Web Activity Leads</TableCell>
                            <TableCell align="center">Listings Activity Leads</TableCell>
                            <TableCell align="center">Call Back Leads</TableCell>
                            <TableCell align="center">Appointment Leads</TableCell>
                            <TableCell align="center">Missed Call Back Leads</TableCell>
                            <TableCell align="center">Missed Appointment Leads</TableCell>
                            <TableCell align="center">Overdue Action Plan Leads</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell align="center">{report.newLeads.length}</TableCell>
                            <TableCell align="center">{report.webActivityLeads.length}</TableCell>
                            <TableCell align="center">
                                {report.listingsActivityLeads.length}
                            </TableCell>
                            <TableCell align="center">{report.callBackLeads.length}</TableCell>
                            <TableCell align="center">{report.appointmentLeads.length}</TableCell>
                            <TableCell align="center">
                                {report.missedCallBackLeads.length}
                            </TableCell>
                            <TableCell align="center">
                                {report.missedAppointmentLeads.length}
                            </TableCell>
                            <TableCell align="center">
                                {report.overdueActionPlanLeads.length}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(2),
    },
}));
